import type { IntlShape } from 'react-intl';

import type { SelectOption } from '@/components/Select';
import type { OrderAppProductVariantsBusinessDetailsQuery } from '@/graphql/orderApp/api';
import { findProductCtaFromBusinessData } from '@/integrations/orderApp';
import { SIZING_TOOL_URL } from '@/lib/const';
import type { Maybe } from '@/lib/types';
import { translateStrapSize } from '@/views/StrapView/components/AddToBagDrawer/helpers';
// 1 sizeA big , 0 = , -1 sizeB big
const SizeValueMap: Record<string, number> = {
  STANDARD: 3,
  SMALL: 2,
  LARGE: 1,
};

export const compareSize = (sizeA = '', sizeB = ''): number => {
  const a = SizeValueMap[sizeA.toUpperCase()] || 0;
  const b = SizeValueMap[sizeB.toUpperCase()] || 0;
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
};

export const findAvaliableSizeItem = (
  items: SelectOption[],
  businessData: Maybe<OrderAppProductVariantsBusinessDetailsQuery>,
) => {
  let result: SelectOption = items[0];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const data = item.data as { id: string; size: string; sku: string };
    const cta = findProductCtaFromBusinessData(businessData, data?.sku);
    if (cta === 'ORDER' || cta === 'PRE_ORDER') {
      if (
        compareSize(
          data.size,
          (result.data as { id: string; size: string; sku: string }).size,
        ) > 0
      ) {
        result = item;
      }
    }
  }
  return result;
};

export const getDownloadBreitlingSizingToolHref = (languageCode: string) => {
  switch (languageCode) {
    case 'en':
      return `${SIZING_TOOL_URL}EN.pdf`;
    case 'es':
      return `${SIZING_TOOL_URL}ES.pdf`;
    case 'fr':
      return `${SIZING_TOOL_URL}FR.pdf`;
    case 'zh':
      return `${SIZING_TOOL_URL}ZH.pdf`;
    case 'de':
      return `${SIZING_TOOL_URL}DE.pdf`;
    case 'it':
      return `${SIZING_TOOL_URL}IT.pdf`;
    case 'ja':
      return `${SIZING_TOOL_URL}JA.pdf`;
    case 'ko':
      return `${SIZING_TOOL_URL}KO.pdf`;
    case 'pt':
      return `${SIZING_TOOL_URL}PT.pdf`;
    case 'nl':
      return `${SIZING_TOOL_URL}NL.pdf`;
    default:
      return `${SIZING_TOOL_URL}EN.pdf`;
  }
};

export const sizeStateOptions = (
  selectItems: SelectOption[],
  formatMessage: IntlShape['formatMessage'],
): SelectOption[] => {
  return selectItems.map((item) => ({
    ...item,
    label: translateStrapSize(item.label, formatMessage),
  }));
};

export const getSelectedSizeItem = (
  selectedItem: Maybe<SelectOption>,
  formatMessage: IntlShape['formatMessage'],
): SelectOption | null => {
  if (!selectedItem) return null;

  return {
    ...selectedItem,
    label: translateStrapSize(selectedItem.label, formatMessage),
  };
};
